<template>
  <div>
    <Banner />
    <About />
    <Schedule />
    <!-- <Intro /> -->
  </div>
</template>

<script>
// @ is an alias to /src
import Intro from '@/components/Intro/Intro.vue'
import Banner from '@/components/Banner/Banner'
import About from '@/components/About/About'
import Schedule from '@/components/Schedule/Schedule'

export default {
  name: 'Home',
  components: {
    Intro
    , Banner
    , About
    , Schedule
  },
  data() {
    return {
    }
  },
  created() {
    
  },
  methods: {
  },
  computed: {
  }
}
</script>


